module.exports = __webpack_public_path__ + "img/pace.8b30909.jpg";